import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'ae-gabby-chat-profanity-modal',
	imports: [],
	templateUrl: './gabby-chat-profanity-modal.component.html',
	styleUrl: './gabby-chat-profanity-modal.component.scss',
})
export class GabbyChatProfanityModalComponent {
	constructor(public activeModal: NgbActiveModal) {}

	public closeModal = () => {
		this.activeModal.close(true);
	};
}
